/**
 * Miscellaneous classes serving as the helpers
 * 
 * @author Vladimir Dosen <vlada.dosen@gmail.com>
 * 
 * @returns {Viewporter}
 */

var Viewporter = function() {
    
    var desktop_size_crossmark  =    1200;
    var tablet_size_crossmark   =    800;
    var mobile_size_crossmark   =    480;
    
    this.setDesktopSizeCrossmark = function (dsc) {
        desktop_size_crossmark = dsc;
        return this;
    };
    this.getDesktopSizeCrossmark = function () {
        return desktop_size_crossmark;
    };
    this.setTabletSizeCrossmark = function (tsc) {
        tablet_size_crossmark = tsc;
        return this;
    };
    this.getTabletSizeCrossmark = function () {
        return tablet_size_crossmark;
    };
    this.setMobileSizeCrossmark = function (msc) {
        mobile_size_crossmark = msc;
        return this;
    };
    this.getMobileSizeCrossmark = function () {
        return mobile_size_crossmark;
    };
    
    this.isMobile = function () {
        return this.getViewportDimensions().width < mobile_size_crossmark;
    };

    this.isTablet = function () {
        return this.getViewportDimensions().width < desktop_size_crossmark && this.getViewportDimensions().width >= mobile_size_crossmark;
    };

    this.isDesktop = function () {
        return this.getViewportDimensions().width >= desktop_size_crossmark;
    };
    
    /**
     * Calculate the Browser's ScrollBar width. How the calculation is performed?
     * 
     * 1.Append two dives to the body and position them off screen
     * 2.Measure the width of the inner div
     * 3.Set the outer div to overflow
     * 4.Measure the width of the inner div (again)
     * 5.Remove the divs
     * 6.Return the difference of the two widths
     * 
     * @returns {Integer}
     */
    this.getScrollBarWidth = function() {
        var inner = document.createElement('p');
        inner.style.width = "100%";
        inner.style.height = "200px";

        var outer = document.createElement('div');
        outer.style.position = "absolute";
        outer.style.top = "0px";
        outer.style.left = "0px";
        outer.style.visibility = "hidden";
        outer.style.width = "200px";
        outer.style.height = "150px";
        outer.style.overflow = "hidden";
        outer.appendChild (inner);

        document.body.appendChild (outer);
        var w1 = inner.offsetWidth;
        outer.style.overflow = 'scroll';
        var w2 = inner.offsetWidth;
        if (w1 == w2) w2 = outer.clientWidth;

        document.body.removeChild (outer);

        return (w1 - w2);
    };
    
    /**
     * Decide the Width x Height of the Viewport of the Browser
     * 
     * @returns {PromotionWindow.getViewportDimensions.promotionWindowAnonym$0}
     */
    this.getViewportDimensions = function () {

        var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

        return {
            width: w,
            height: h
        };

    };
    
};